import React, { useState } from "react";
import "../css/Workout.css";

const Workouts = () => {
  const [activeTab, setActiveTab] = useState("strength");

  return (
    <div className="workouts">

      {/* =========================================
          HERO PANEL
      ========================================== */}
      <section className="wk-hero">
        <img 
          src="https://images.unsplash.com/photo-1574680096145-d05b474e2155"
          alt="Workouts Hero"
        />
        <div className="wk-hero-text">
          <h1>THE ACE WORKOUT SYSTEM</h1>
          <p>Engineered for athletes chasing real performance.</p>
        </div>
      </section>



      {/* =========================================
          PROGRAM CATEGORY SWITCHER
      ========================================== */}
      <section className="wk-tabs">
        <div 
          className={`wk-tab ${activeTab === "strength" ? "active" : ""}`}
          onClick={() => setActiveTab("strength")}
        >
          Strength
        </div>

        <div 
          className={`wk-tab ${activeTab === "conditioning" ? "active" : ""}`}
          onClick={() => setActiveTab("conditioning")}
        >
          Conditioning
        </div>

        <div 
          className={`wk-tab ${activeTab === "mobility" ? "active" : ""}`}
          onClick={() => setActiveTab("mobility")}
        >
          Mobility
        </div>
      </section>


      {/* CONTENT FOR TABS */}
      <section className="wk-content">

        {activeTab === "strength" && (
          <div className="wk-text-block">
            <h2>RAW STRENGTH</h2>
            <p>
              Built for athletes who want dense muscle, exceptional stability,
              and high-output power. Progressive overload meets ACE form standards.
            </p>
          </div>
        )}

        {activeTab === "conditioning" && (
          <div className="wk-text-block">
            <h2>HIGH VELOCITY CONDITIONING</h2>
            <p>
              Heart-rate driven work designed for peak intensity and rapid recovery.
            </p>
          </div>
        )}

        {activeTab === "mobility" && (
          <div className="wk-text-block">
            <h2>STRUCTURAL MOBILITY</h2>
            <p>
              Move cleaner. Stabilize joints. Unlock deeper range and reduce risk.
            </p>
          </div>
        )}

      </section>



      {/* =========================================
          GRID OF MOVEMENT TYPES
      ========================================== */}
      <section className="wk-grid">
        <div className="wk-grid-item tall" style={{backgroundImage:`url(https://images.unsplash.com/photo-1574680096145-d05b474e2155)`}}>
          <h3>POWER LIFTS</h3>
        </div>

        <div className="wk-grid-item" style={{backgroundImage:`url(https://images.pexels.com/photos/7187841/pexels-photo-7187841.jpeg)`}}>
          <h3>ATHLETIC DRILLS</h3>
        </div>

        <div className="wk-grid-item wide" style={{backgroundImage:`url(https://images.pexels.com/photos/35388280/pexels-photo-35388280.jpeg)`}}>
          <h3>ENDURANCE CIRCUITS</h3>
        </div>

        <div className="wk-grid-item" style={{backgroundImage:`url(https://images.pexels.com/photos/2294361/pexels-photo-2294361.jpeg)`}}>
          <h3>CORE SYSTEM</h3>
        </div>

        <div className="wk-grid-item tall" style={{backgroundImage:`url(https://images.pexels.com/photos/7320099/pexels-photo-7320099.jpeg)`}}>
          <h3>MOBILITY FLOW</h3>
        </div>
      </section>



      {/* =========================================
          INTENSITY BAR PANEL
      ========================================== */}
      <section className="wk-intensity">
        <h2>INTENSITY PROFILE</h2>

        <div className="intensity-row">
          <span>Power</span>
          <div className="bar"><div style={{width:"92%"}}></div></div>
        </div>

        <div className="intensity-row">
          <span>Stamina</span>
          <div className="bar"><div style={{width:"78%"}}></div></div>
        </div>

        <div className="intensity-row">
          <span>Mobility</span>
          <div className="bar"><div style={{width:"65%"}}></div></div>
        </div>
      </section>



      {/* =========================================
          FORMS + STRUCTURE SPLIT PANEL
      ========================================== */}
      <section className="wk-structure">
        <div className="wk-structure-left">
          <h2>FORM FIRST.</h2>
          <p>
            Every ACE workout is constructed with structural balance in mind.
            No wasted reps. No noise. Just clean movement mechanics that scale 
            performance and protect longevity.
          </p>
        </div>

        <div className="wk-structure-right">
          <img 
            src="https://images.unsplash.com/photo-1574680096145-d05b474e2155"
            alt="Structure"
          />
        </div>
      </section>



      {/* =========================================
          SLANTED STRIP — SIGNATURE MOVEMENT
      ========================================== */}
      <section className="wk-slanted">
        <div className="slanted-overlay"></div>
        <h1>THE ACE MOVEMENT STANDARD</h1>
      </section>


    </div>
  );
};

export default Workouts;